import React from "react";
import Form from "react-bootstrap/Form";

const MeetingInvite = () => {
  return (
    <div className="meetinginvite_sec">
      <div className="qep_grad mt-4 border-none">
        <h2 className="d-flex align-items-center">
          <svg
            className="me-2"
            width="20"
            height="15"
            viewBox="0 0 20 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19.086 6.37324H3.10268L7.91332 1.56261C8.00012 1.47877 8.06936 1.37848 8.117 1.26759C8.16463 1.15671 8.1897 1.03744 8.19075 0.916765C8.1918 0.796086 8.1688 0.676407 8.1231 0.56471C8.0774 0.453014 8.00992 0.351537 7.92458 0.266201C7.83925 0.180865 7.73777 0.113379 7.62607 0.06768C7.51438 0.0219814 7.3947 -0.00101435 7.27402 3.43162e-05C7.15334 0.00108298 7.03408 0.0261553 6.92319 0.0737881C6.81231 0.121421 6.71202 0.190661 6.62818 0.277467L0.266104 6.63954C0.0957178 6.80998 0 7.04111 0 7.28211C0 7.52311 0.0957178 7.75424 0.266104 7.92468L6.62818 14.2868C6.79959 14.4523 7.02917 14.5439 7.26748 14.5418C7.50578 14.5398 7.73373 14.4442 7.90225 14.2757C8.07076 14.1072 8.16634 13.8792 8.16841 13.6409C8.17048 13.4026 8.07887 13.173 7.91332 13.0016L3.10268 8.19098H19.086C19.3271 8.19098 19.5582 8.09522 19.7287 7.92478C19.8991 7.75433 19.9949 7.52316 19.9949 7.28211C19.9949 7.04106 19.8991 6.80989 19.7287 6.63944C19.5582 6.469 19.3271 6.37324 19.086 6.37324Z"
              fill="#666666"
            />
          </svg>
          Meeting Invite
        </h2>
      </div>
      <div className="common_card ">
        <form action="">
          <div className="qep_grad">
            <h2>Quarterly Quality Council Meeting Minutes</h2>
            <ul className="meetinvite_item">
              <li>
                Agency:<span> Bright Path Support Coordination</span>
              </li>
              <li>
                Meeting Type:<span> Quarterly Quality Council Meeting</span>
              </li>
              <li>
                Date:<span> May 23, 2025</span>
              </li>
            </ul>
          </div>
          <div className="meetinginvite_inner mb-3 row">
            <div className="qep_grad pb-2">
              <h2>Attendance</h2>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="goal_left">
                <div className="mb-3">
                  <label className="form-label">
                    Sarah Jennings
                    <span className="sep_cont">(Program Manager)</span>
                  </label>
                  <select
                    className="form-select mb-3"
                    aria-label="Default select example"
                  >
                    <option selected>Select</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="goal_left">
                <div className="mb-3">
                  <label className="form-label">
                    Mark DeSoto
                    <span className="sep_cont"> (Director of QA)</span>
                  </label>
                  <select
                    className="form-select mb-3"
                    aria-label="Default select example"
                  >
                    <option selected>Select</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="goal_left">
                <div className="mb-3">
                  <label className="form-label">
                    Laura Nguyen
                    <span className="sep_cont">
                      (Support Coordination Supervisor)
                    </span>
                  </label>
                  <select
                    className="form-select mb-3"
                    aria-label="Default select example"
                  >
                    <option selected>Select</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="goal_left">
                <div className="mb-3">
                  <label className="form-label">
                    Jamal Rivers
                    <span className="sep_cont">(Data Analyst)</span>
                  </label>
                  <select
                    className="form-select mb-3"
                    aria-label="Default select example"
                  >
                    <option selected>Select</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="goal_left">
                <div className="mb-3">
                  <label className="form-label">
                    Mark DeSoto
                    <span className="sep_cont">(Director of QA)</span>
                  </label>
                  <select
                    className="form-select mb-3"
                    aria-label="Default select example"
                  >
                    <option selected>Select</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="goal_left">
                <div className="mb-3">
                  <label className="form-label">
                    Laura Nguyen
                    <span className="sep_cont">
                      (Support Coordination Supervisor)
                    </span>
                  </label>
                  <select
                    className="form-select mb-3"
                    aria-label="Default select example"
                  >
                    <option selected>Select</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="meetinginvite_inner mb-3  row">
            <div className="qep_grad">
              <h2>Performance Indicator (PI) Data</h2>
              <p>
                PIs are your core, board-approved metrics tracked every quarter
                (e.g., visit compliance, satisfaction scores, incident
                reporting, documentation timeliness). Complete each with the
                current strength/need and trends/patterns for this period.s
              </p>
            </div>
            <div className="meetingper_item mb-3 row">
              <div className="col-md-6 col-lg-4">
                <div className="indicatiors mb-3">
                  Participant Satisfaction Survey Score
                </div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div className="indicatiors mb-3">Current: 88%</div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div className="indicatiors mb-3">Up from 84% last quarter</div>
              </div>
              <div className="col-12">
                <div className="indicatiors indi_sum">
                  Summary: Why is this trending? What are the strengths/needs?
                </div>
              </div>
            </div>
            <div className="meetingper_item mb-3 row">
              <div className="col-md-6 col-lg-4">
                <div className="indicatiors mb-3">
                  Employee Satisfaction Survey Score
                </div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div className="indicatiors mb-3">Current: 82%</div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div className="indicatiors mb-3">No change from last year</div>
              </div>
              <div className="col-12">
                <div className="indicatiors indi_sum">
                  Summary: Why is this trending? What are the strengths/needs?
                </div>
              </div>
            </div>
            <div className="meetingper_item mb-3 row">
              <div className="col-md-6 col-lg-4">
                <div className="indicatiors mb-3">
                  CIR Submission & Timeliness Rate
                </div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div className="indicatiors mb-3">98% on time (49/50)</div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div className="indicatiors mb-3">
                  Slight decrease: 100% last quarter
                </div>
              </div>
              <div className="col-12">
                <div className="indicatiors indi_sum">
                  Summary: Why is this trending? What are the strengths/needs?
                </div>
              </div>
            </div>
            <div className="meetingper_item  row">
              <div className="col-md-6 col-lg-4">
                <div className="indicatiors mb-3">
                  Task/Meeting Completion Timeliness
                </div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div className="indicatiors mb-3">93% on time</div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div className="indicatiors mb-3">
                  Improved from 88% last quarter
                </div>
              </div>
              <div className="col-12">
                <div className="indicatiors indi_sum">
                  Summary: Why is this trending? What are the strengths/needs?
                </div>
              </div>
            </div>
          </div>
          <div className="meetinginvite_inner mb-3  row">
            <div className="qep_grad ps-0">
              <h2>QE Plan Implementation Report</h2>
            </div>
            <div className="table-responsive p-0">
              <table className="common_table table">
                <thead>
                  <tr>
                    <th>Activity</th>
                    <th>Update</th>
                    <th>Date Completed</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <span>Staff CIR retraining</span>
                    </td>
                    <td>
                      <span>Completed</span>
                    </td>
                    <td>
                      <span>05/01/2025</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Family/participant survey sent</span>
                    </td>
                    <td>
                      <span>Completed</span>
                    </td>
                    <td>
                      <span>04/20/2025</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Policy updates issued</span>
                    </td>
                    <td>
                      <span>Completed</span>
                    </td>
                    <td>
                      <span>03/05/2025</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>System-based audit</span>
                    </td>
                    <td>
                      <span>Completed</span>
                    </td>
                    <td>
                      <span>03/10/2025</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Staff training module completion</span>
                    </td>
                    <td>
                      <span>Completed</span>
                    </td>
                    <td>
                      <span>04/12/2025</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="meetinginvite_inner mb-3  row">
            <div className="qep_grad ps-0">
              <h2>QE Plan Effectiveness Report</h2>
            </div>
            <div className="table-responsive p-0">
              <table className="common_table table">
                <thead>
                  <tr>
                    <th>Goal</th>
                    <th>Benchmark for this Quarter</th>
                    <th>Benchmark Met?</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <span>Increase SC documentation accuracy</span>
                    </td>
                    <td>
                      <span>90% compliance in audits</span>
                    </td>
                    <td>
                      <span>Yes</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Decrease unnecessary ER visits</span>
                    </td>
                    <td>
                      <span>15% reduction in high-risk group</span>
                    </td>
                    <td>
                      <span>No</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Raise participant satisfaction above 85%</span>
                    </td>
                    <td>
                      <span>Mid-year target 83%</span>
                    </td>
                    <td>
                      <span>No</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>System-based audit</span>
                    </td>
                    <td>
                      <span>Completed</span>
                    </td>
                    <td>
                      <span>03/10/2025</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Staff training module completion</span>
                    </td>
                    <td>
                      <span>Completed</span>
                    </td>
                    <td>
                      <span>04/12/2025</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="meetinginvite_inner mb-3 row">
            <div className="col-md-6 col-lg-4">
              <div className="mb-3">
                <label className="form-label">Recommendations</label>
                <textarea
                  className="form-control"
                  id="exampleFormControlTextarea1"
                  rows={3}
                  placeholder="Recommendations discussed on the call..."
                ></textarea>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="mb-3">
                <label className="form-label">Trends & Patterns Observed</label>
                <textarea
                  className="form-control"
                  id="exampleFormControlTextarea1"
                  rows={3}
                  placeholder="Trends and patterns observed during review..."
                ></textarea>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="mb-3">
                <label className="form-label">Agency Strengths</label>
                <textarea
                  className="form-control"
                  id="exampleFormControlTextarea1"
                  rows={3}
                  placeholder="Agency strengths identified..."
                ></textarea>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="mb-3">
                <label className="form-label">Agency Needs</label>
                <textarea
                  className="form-control"
                  id="exampleFormControlTextarea1"
                  rows={3}
                  placeholder="Agency needs identified..."
                ></textarea>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="mb-3">
                <label className="form-label">Recommended Priorities</label>
                <textarea
                  className="form-control"
                  id="exampleFormControlTextarea1"
                  rows={3}
                  placeholder="Recommended priorities moving forward..."
                ></textarea>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="mb-3">
                <label className="form-label">
                  Recommended Initiatives to Add
                </label>
                <textarea
                  className="form-control"
                  id="exampleFormControlTextarea1"
                  rows={3}
                  placeholder="New initiatives proposed..."
                ></textarea>
              </div>
            </div>
          </div>
          <div className="meetinginvite_inner row">
            <Form className="meeting_check">
              <Form.Check>
                <Form.Check.Input isValid />
                <Form.Check.Label>
                  I certify that the following statement was read aloud to all
                  participants at this meeting:
                </Form.Check.Label>
                <Form.Control.Feedback type="valid">
                  "As required by agency policy and state/federal standards, the
                  meeting agenda and minutes were reviewed aloud and all present
                  had an opportunity to ask questions or correct the record."
                </Form.Control.Feedback>
              </Form.Check>
            </Form>
          </div>
          <div className="goalsave_btn meeting_btn mt-3">
            <input
              type="submit"
              className="form-control"
              id="exampleFormControlInput1"
              value="Submit QEP Minutes"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default MeetingInvite;
